import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

const SvgClose = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill={baseColors.green.primary}
                    d="M11.832 10.016L19.62 2.23A1.294 1.294 0 1017.788.397L10 8.183 2.212.396A1.294 1.294 0 10.38 2.23l7.788 7.787L.38 17.804a1.294 1.294 0 00.916 2.212c.332 0 .664-.127.916-.38L10 11.85l7.788 7.787a1.292 1.292 0 001.832 0 1.294 1.294 0 000-1.832l-7.788-7.788z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h20v20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgClose
